import { render, staticRenderFns } from "./LiveRoomList.vue?vue&type=template&id=33d4cb88&scoped=true&"
import script from "./LiveRoomList.vue?vue&type=script&lang=js&"
export * from "./LiveRoomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4cb88",
  null
  
)

export default component.exports